export default "__VITE_ASSET__C4HPueJ6__"